import {parse, parseISO, format, setDefaultOptions, formatISO} from "date-fns";
import { ms }  from "date-fns/locale/ms";

setDefaultOptions({ locale: ms })
export const sumFormat = (sum: number): string => new Intl.NumberFormat("ms-MY", { minimumFractionDigits: 2, maximumFractionDigits: 2, style: "currency", currency: "MYR"}).format(sum);
export const sumFormatWithoutCurrency = (sum: number): string => new Intl.NumberFormat("ms-MY", { minimumFractionDigits: 2, maximumFractionDigits: 2}).format(sum);
export const sumFormatWithoutDecimal = (sum: number): string => new Intl.NumberFormat("ms-MY", { minimumFractionDigits: 0}).format(sum);
export const formatDateWithSeconds = (dateInput: string) => format(parse(dateInput,"yyyy-MM-dd HH:mm:ss",new Date(dateInput)),"dd-MM-yyyy HH:mm:ss");
export const formatDateOnly = (dateInput: string) => format(parse(dateInput,"yyyy-MM-dd",new Date(dateInput)),"dd-MM-yyyy");
export const formatDateISO = (dateInput: string) => format(parseISO(dateInput),"dd-MM-yyyy HH:mm:ss");
export const parseDateData = (date :string): string => (date !== undefined)? formatISO(new Date(date)):"";

export const validateEmail = (email: string): boolean => /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/g.test(email);
export const validatePhone = (phone: string): boolean => /^(01)[02-46-9][0-9]{7}$|^(01)1[0-9]{8}$|^(0)[2-9][0-9]{6,8}$/g.test(phone);

export const arrayMonth = ():Array<number> => {
    let monthRange:Array<number> = [];
    for(let m = 0; m < 12; m++){
        monthRange.push(m+1);
    }
    return monthRange;
};
export const arrayYear = (currentYear: number):Array<number> => {
    let yearRange:Array<number> = [];
    for(let y = currentYear; y >= 2015; y--){
        yearRange.push(y);
    }
    return yearRange;
};

const _ = {
    sumFormat,
    sumFormatWithoutCurrency,
    sumFormatWithoutDecimal,
    formatDateWithSeconds,
    formatDateOnly,
    formatDateISO,
    arrayMonth,
    arrayYear,
    parseDateData,
}
export default _;
